export default __webpack_public_path__ + "static/media/reception2.6ce35e96.jpg";